import React from 'react';
import { Helmet } from 'react-helmet';
import { useAuth as useClerkAuth } from '@clerk/clerk-react';
import dayjs from 'dayjs';
import useAuth from '../../../hooks/useAuth';

const PUBLIC_APP_URL = 'https://app.tlknow.ai';

const AccessDenied = () => {
  const { signOut } = useClerkAuth();
  const { Logout } = useAuth();

  const handleSignOut = async () => {
    try {
      await Logout();
    } catch (err) {
      console.warn('Logout cleanup failed', err);
    }
    await signOut({ redirectUrl: '/login' });
  };

  return (
    <>
      <Helmet>
        <title>Access unavailable | TLK</title>
      </Helmet>
      <div className="main-body access-denied-page">
        <div className="body-content">
          <form className="form-content-s1">
            <div className="access-denied-panel">
              <h1>Oops, you shouldn't be here</h1>
              <p>
                Looking for the TLK app?{' '}
                <a href={PUBLIC_APP_URL} className="text-btn">
                  Click here
                </a>
              </p>
              <div className="form-submit-group">
                <button
                  type="button"
                  className="gradient-btn full-size-btn"
                  onClick={handleSignOut}
                >
                  <span className="text">Sign out</span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className="bottom-cpx-text">
          <p>Copyright © {dayjs().format('YYYY')}, Syntimacy LLC</p>
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
